import { DeleteVideo, ReorderedVideos } from "../../redux/videos";
import {
  IoAddCircleOutline,
  IoCheckboxOutline,
  IoCloseSharp,
  IoEyeOutline,
  IoPencilOutline,
  IoTrash,
} from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { AppLinks } from "../../components/links";
import { DragDropContainer } from "../../components/inputs";
import { ErrorBanner } from "../../components/banner";
import { FetchVideos } from "../../redux/videos";
import { Link } from "react-router-dom";
import { Loading } from "../../components/loader";
import { PageHeader } from "../../components/header";
import { Section } from "../../components/section";
import { Text } from "../../components/typography";
import { VideoDetailFetch } from "./VideoDetailFetch";
import styled from "styled-components";

export const VideoList = () => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState({});

  const dispatch = useDispatch();
  const { loading, error, videos, isDownloading, downloadProgress } =
    useSelector((state) => state.videos);

  const onToggleOpenClose = () => {
    setOpen(!open);
  };

  const onDisplayImages = (data) => {
    console.log("Data: ", data);
    onToggleOpenClose();
    setSelected(data);
  };

  const onRemoveDisplayImage = () => {
    onToggleOpenClose();
    setSelected({});
  };

  const onDeleteSubmit = (value) => {
    if (window.confirm("Are you sure you want to delete this?")) {
      dispatch(DeleteVideo(value));
      onToggleOpenClose();
    }
  };

  const handleReorder = (reorderedList) => {
    dispatch(ReorderedVideos(reorderedList));
  };

  useEffect(() => {
    dispatch(FetchVideos());
  }, [dispatch]);

  if (loading || isDownloading) {
    return <Loading progress={downloadProgress} />;
  }

  if (!videos) {
    return null;
  }

  return (
    <div>
      <PgContainer title="Videos">
        <Link to={`/gallery/videos/create`}>
          <IoAddCircleOutline />
        </Link>
      </PgContainer>
      {error && <ErrorBanner text={error} />}
      <Section>
        <DataRowListHeader>
          <Text>Order</Text>
          <Text>Title</Text>
          <Text>View</Text>
          <Text>Featured</Text>
          <Text>Edit</Text>
        </DataRowListHeader>
        <DragDropContainer
          items={videos}
          onReorder={handleReorder}
          renderItem={(video, index) => (
            <DataRowList>
              <Text>{index + 1}</Text>
              <Text>{video.title}</Text>
              <IoEyeOutline onClick={() => onDisplayImages(video)} />
              {video.featured ? <IoCheckboxOutline /> : <IoCloseSharp />}

              <AppLinks
                to={`/gallery/videos/${video.id}/edit`}
                state={{ video: video }}
              >
                <IoPencilOutline />
              </AppLinks>
            </DataRowList>
          )}
        />
      </Section>
      <VideoDetailFetch
        video={selected?.url}
        description={selected?.description}
        title={selected?.title}
        open={open}
        onToggleOpenClose={onRemoveDisplayImage}
        components={
          <div>
            <IoTrash onClick={() => onDeleteSubmit(selected)} />
            <AppLinks
              to={`/gallery/videos/${selected.id}/edit`}
              state={{ video: selected }}
            >
              <IoPencilOutline />
            </AppLinks>
          </div>
        }
      />
    </div>
  );
};
export default VideoList;

const PgContainer = styled(PageHeader)`
  padding: 0;
  display: flex;
`;

const DataRowListHeader = styled.header`
  display: grid;
  grid-template-columns: 0.1fr 2fr 0.1fr 0.2fr auto;
  font-size: 0.9rem;
  font-weight: 500;
  gap: 0.5rem;
  text-align: left;
  padding: 0 10px;
`;

const DataRowList = styled.div`
  display: grid;
  grid-template-columns: 0.1fr 2fr 0.1fr 0.2fr auto;
  align-items: center;
  gap: 0.5rem;
  padding: 10px;
  border-bottom: 1px solid #eee;
  background-color: #fff;
  cursor: grab;

  p {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  svg {
    align-items: center;
    margin: auto;
  }

  &:hover {
    background-color: #f9f9f9;
  }
`;
